var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCovDesignResponsive = function SvgCovDesignResponsive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176.952,
    height: 106.507,
    viewBox: "0 0 176.952 106.507",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.9 0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.212,662.85H434.747V576.559h123.91v1.8H436.547V661.05H540.212Z",
    transform: "translate(-435.647 -577.459)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9,22.658H-.9V-.9H.9Z",
    transform: "translate(122.11 11.995)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.747,636.518H456.9V618.125h32.947v1.8H458.7v14.794h30.247v-9.9h1.8Z",
    transform: "translate(-412.767 -534.532)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.013.9H0V-.9H55.013Z",
    transform: "translate(33.55 101.087)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.034.9H0V-.9H91.034Z",
    transform: "translate(0 70.366)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.766,665.921H485.743V593.16h55.022v16.519h-1.8V594.96H487.543v69.161h53.223Z",
    transform: "translate(-382.978 -560.314)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3.9H-.9V-.9H7.3Z",
    transform: "translate(127.565 94.296)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H27.609V45.064H-.9ZM25.809.9H.9V43.264H25.809Z",
    transform: "translate(148.443 60.542)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.881.9H-.9V-.9H2.881Z",
    transform: "translate(160.807 95.558)",
    fill: "#183149"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovDesignResponsive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cov-design-responsive.e7e712d6.svg";
export { ForwardRef as ReactComponent };